export const PhotosConstants = {
  PhotoTypes: {
    Selfie: { id: 12, name: 'ID' },
    Id: { id: 13, name: 'Selfie' },
    AdditionalSelfie: { id: 22, name: 'Additional ID' },
    AdditionalId: { id: 23, name: 'Additional Selfie' },
  },
  PhotoStatuses: {
    PendingReview: 'pending_review',
    Approved: 'approved',
    Rejected: 'rejected',
    Deleted: 'deleted',
  },
};
